class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.closeDelay = 200;
    this.closeTimeout = null;
    this.isClosing = false;
    this.isDesktop = window.matchMedia('(min-width: 990px)').matches;

    if (this.isDesktop) {
      this.addEventListener('mouseenter', this.onMouseEnter.bind(this));
      this.addEventListener('mouseleave', this.onMouseLeave.bind(this));
      this.mainDetailsToggle.querySelector('summary').addEventListener('click', (e) => {
        if (this.mainDetailsToggle.hasAttribute('open')) {
          e.preventDefault();
        }
      });
    }
  }

  onMouseEnter() {
    clearTimeout(this.closeTimeout);
    if (this.isClosing) {
      this.isClosing = false;
      this.mainDetailsToggle.classList.remove('mega-menu--closing');
    }
    this.open();
  }

  onMouseLeave() {
    this.closeTimeout = setTimeout(() => this.close(), this.closeDelay);
  }

  open() {
    if (this.mainDetailsToggle.hasAttribute('open')) return;
    this.mainDetailsToggle.classList.add('mega-menu--opening');
    this.mainDetailsToggle.setAttribute('open', '');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', 'true');
    this.content.offsetHeight;
    this.mainDetailsToggle.classList.remove('mega-menu--opening');
  }

  close() {
    if (!this.isDesktop || !this.mainDetailsToggle.hasAttribute('open')) {
      super.close();
      return;
    }

    this.isClosing = true;
    this.mainDetailsToggle.classList.add('mega-menu--closing');

    const onDone = () => {
      this.content.removeEventListener('transitionend', onDone);
      clearTimeout(fallback);
      if (!this.isClosing) return;
      this.isClosing = false;
      this.mainDetailsToggle.classList.remove('mega-menu--closing');
      super.close();
    };

    this.content.addEventListener('transitionend', onDone, { once: true });
    const fallback = setTimeout(onDone, 350);
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
